import { AnyAction } from 'redux';

import { TempDataState, tempDataActions } from './tempData.types';

export const tempDataInitialState: TempDataState = {};

export const tempDataReducer: (state: TempDataState | undefined, action: AnyAction) => TempDataState = (
	state = tempDataInitialState,
	action
): TempDataState => {
	if (action.type === tempDataActions.saveTempData) {
		return {
			...state,
			...action.payload,
		};
	}
	return state;
};
